export const ENTRY_SOURCE_KEY = 'entry_source';

export const SOURCE_RECORDING = 'recording';

// TODO: replace after release
export const DEPLOYMENT_CUTOFF = new Date('2026-04-22T00:00:00Z');
